/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_OutroInputs */

const en_wb_management_outro = /** @type {(inputs: Wb_Management_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each item links back to its source record in the connected system.`)
};

const lv_wb_management_outro = /** @type {(inputs: Wb_Management_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katrs punkts ved atpakaļ uz savu avota ierakstu pievienotajā sistēmā.`)
};

/**
* | output |
* | --- |
* | "Each item links back to its source record in the connected system." |
*
* @param {Wb_Management_OutroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_outro = /** @type {((inputs?: Wb_Management_OutroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_OutroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_outro(inputs)
	return en_wb_management_outro(inputs)
});